import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Collapse } from 'antd';
import { LayersWithSectionsNodeModel, LayerWithSectionsModel } from '../../models';
import { GetComponentRowsFunction } from '../../componentTypes';
import { CollapseExpandIcon } from '../../../custom_shared/components';
import { SubmissionScopeSelect } from '../../components';
import SectionRenderer from './SectionRenderer';
import './LayerWithSectionsRenderer.less';

interface Props {
    node: LayersWithSectionsNodeModel;
    layer: LayerWithSectionsModel;
    getComponentRows: GetComponentRowsFunction;
    addLayerRef: (layerId: string, layerRef: React.RefObject<HTMLDivElement>) => void;
}

const LayerWithSectionsRenderer: React.FC<Props> = (props: Props) => {
    const { node, layer, getComponentRows, addLayerRef } = props;

    const ref = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        addLayerRef(layer.id, ref);
    }, [layer.id, addLayerRef]);

    return (
        <div ref={ref} className="layer-with-sections-renderer-container">
            <Collapse
                key={layer.id}
                activeKey={layer.expanded ? [layer.id] : []}
                onChange={layer.toggleExpanded}
                bordered={false}
                expandIcon={CollapseExpandIcon}
            >
                <Collapse.Panel
                    className="layer-with-sections-collapse-panel"
                    header={
                        <div className="layers-with-sections-layout-layer-header-container">
                            <span className="header-title">{layer.name}</span>
                            <div
                                className="layers-with-sections-layout-submission-scope-container"
                                onClick={event => event.stopPropagation()}
                            >
                                <SubmissionScopeSelect
                                    submissionScope={layer.submissionScope}
                                    setSubmissionScope={scope => layer.setSubmissionScope(scope)}
                                    mainSectionLabel="For the entire layer (Main Section)"
                                    tooltipText="Please specify if instalment terms cover the entire layer or are defined for each section separately."
                                    style={{ paddingRight: 0 }}
                                />
                            </div>
                        </div>
                    }
                    key={layer.id}
                >
                    {layer.sections
                        .filter(section => !section.isHidden)
                        .map(section => (
                            <SectionRenderer
                                key={section.id}
                                node={node}
                                layer={layer}
                                section={section}
                                getComponentRows={getComponentRows}
                            />
                        ))}
                </Collapse.Panel>
            </Collapse>
        </div>
    );
};

export default observer(LayerWithSectionsRenderer);
